module.exports = __webpack_public_path__ + "img/GAME_SEAWORLD2.b724a67d.jpg";